define('webshopLandingpagesListFiltersView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'settings',
  'moment',
  'webshopLandingpagesListFiltersEditView',
  'filtersBannerView',
  'entities/webshop/landingpages'
], function(
  App,
  Module,
  Backbone,
  _,
  Settings,
  moment,
  EditView,
  FiltersBannerView
) {
  'use strict';
  
  Module.exports = FiltersBannerView.extend({
    editViewClass: EditView,

    initialize: function() {
      this.tableView = this.options.tableView;
      var settings = Settings.get('webshopLandingpagesListFilters', true);

      var defaultAttributes = {        
        category: ''
      };

      if(settings) {
        var attributes = _.extend({}, defaultAttributes, JSON.parse(settings));
        this.model = new Backbone.Model(attributes);
      } else {
        this.model = new Backbone.Model(defaultAttributes);
        Settings.set('webshopLandingpagesListFilters', JSON.stringify(this.model.attributes), true);
      }
      this.tableView.filters = this.model;

      FiltersBannerView.prototype.initialize.apply(this, arguments);
    },

    setCollection: function() {
      if(this.model.get('status')) {
        var status = '';
        if(this.model.get('status') === '0')
          status = _.i18n('common.disabled');
        if(this.model.get('status') === '1')
          status = _.i18n('common.enabled');

        this.collection.add(new Backbone.Model({
          id: 'status',
          libelle: _.i18n('common.status'),
          value: status
        }));
      }             

      //----------------
      if(this.model.get('category') && this.model.get('category').code) {
        this.collection.add(new Backbone.Model({
          id: 'category',
          libelle: _.i18n('common.category'),
          value: this.model.get('category').code
        }));
      }

      //----------------
      if(this.model.get('code')) {
        this.collection.add(new Backbone.Model({
          id: 'code',
          libelle: _.i18n('common.code'),
          value: this.model.get('code')
        }));
      }   

      //----------------
      FiltersBannerView.prototype.setCollection.apply(this, arguments);
    },

    onDeleteFilter: function(model, filterModel) {
      if(filterModel.get('id') === 'category') {
        model.get('category').id = '';
        model.get('category').code = '';
      } else
        model.set(filterModel.get('id'), '');
    },

    fetch: function(model) {
      var needFetch = false;    

      if(this.model.get('code') !== model.get('code'))
        needFetch = true;    

      if(this.model.get('status') !== model.get('status'))
        needFetch = true;

      if(this.model.get('category').id !== model.get('category').id)
        needFetch = true;     

      FiltersBannerView.prototype.fetch.apply(this, arguments);
      Settings.set('webshopLandingpagesListFilters', JSON.stringify(this.model.attributes), true);

      if(needFetch) {
        this.tableView.footerView.setCurrentPage(1);
        this.tableView.bodyView.fetch();
        this.tableView.footerView.fetch();
      }
    }
  });  
});

